module.exports = __webpack_public_path__ + "img/yngl.ec1df697.png";